import { render, staticRenderFns } from "./adminManagement.vue?vue&type=template&id=52148f11&scoped=true"
import script from "./adminManagement.vue?vue&type=script&lang=js"
export * from "./adminManagement.vue?vue&type=script&lang=js"
import style0 from "./adminManagement.vue?vue&type=style&index=0&id=52148f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52148f11",
  null
  
)

export default component.exports